import {memo} from 'react';

import styled from 'styled-components';

import ImageWithAlt from '~/shared/components/ImageWithAlt';
import {body14Normal} from '~/shared/theme/typography';

const StatusRoot = styled.div<{bgColor: string}>`
  ${body14Normal}
  width: 100%;
  height: 44px;
  padding: 12px;
  background-color: ${({bgColor}) => bgColor};
  gap: 8px;
  display: flex;
  border-radius: 12px;
  line-height: 21px;
`;

type StatusBarProps = {
  className?: string;
  text: string;
  bgColor: string;
  iconUrl: string;
};

const StatusBar = ({text, bgColor, iconUrl, className}: StatusBarProps) => {
  return (
    <StatusRoot bgColor={bgColor} className={className}>
      <ImageWithAlt src={iconUrl} noAlt />
      {text}
    </StatusRoot>
  );
};

export default memo(StatusBar);
